"use client";

import { useState } from "react";

import { Plus } from "lucide-react";

import { Button } from "@/components/_ui/button";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/_ui/popover";

import { PublicTrackingLookup } from "./PublicTrackingLookup";

/**
 * Header "New IMb" button — opens a popover containing the IMb lookup
 * form. On a successful lookup, the form syncs the URL (`?imb=...`) which
 * updates the dashboard underneath; the popover closes via the
 * `onSubmitSuccess` callback.
 */
export function NewImbButton() {
  const [open, setOpen] = useState(false);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button>
          <Plus aria-hidden />
          New IMb
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-[26rem]">
        <PublicTrackingLookup onSubmitSuccess={() => setOpen(false)} />
      </PopoverContent>
    </Popover>
  );
}
